import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ContactService } from 'src/app/cms/contact/contact.service';
import { environment } from 'src/environments/environment';
import { Contact } from './contact';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  private contact$: Observable<any>
  contact: Contact
  imageBaseUrl = environment.resourceUrl+'/image/'

  constructor(
    private contactService: ContactService,
    private route: ActivatedRoute,
    private router: Router,
  ) {

  }

  ngOnInit() {
    this.contact$ = this.contactService.getContact()
    this.contact$.subscribe(data => {
      this.contact = data
    })
  }
}
